import actions from './actions';
import reducer from './reducer';

const configs = {
    actions,
    reducer,
    name: 'configs',
};

export default configs;
